import helper from '../../helper';

export default {
	state: {
		receivable: {
			// 应收款、临时收费
			loading: false,
			data: { list: [] },
		},
		otherReceivable: {
			// 其他收费项
			loading: false,
			data: { list: [] },
		},
		currentProjectInfo: {},
		operRecord: 0,
		xfOperRecord: 0,
	},
	mutations: {
		requestReceivable(state) {
			state.receivable.loading = true;
		},
		successReceivable(state, data) {
			state.receivable.loading = false;
			state.receivable.data = data;
		},
		requestOtherReceivable(state) {
			state.otherReceivable.loading = true;
		},
		successOtherReceivable(state, data) {
			state.otherReceivable.loading = false;
			state.otherReceivable.data = data;
		},
		setProjectInfo(state, data) {
			state.currentProjectInfo = data;
		},
		setOperRecord(state, data) {
			state.operRecord = data;
		},
		setXfOperRecord(state, data) {
			state.xfOperRecord = data;
		},
	},
	actions: {
		async getReceivable({ commit }, params) {
			return helper(this, async () => {
				commit('requestReceivable');
				const res = await a.api('getYskAndXfList', params);
				commit('successReceivable', res.result);
			});
		},
		async getOtherReceivable({ commit }, params) {
			return helper(this, async () => {
				commit('requestOtherReceivable');
				const res = await a.api('getNotYskAndXfList', params);
				commit('successOtherReceivable', res.result);
			});
		},
		async getCurrentProjectInfo({ commit }, params) {
			return helper(this, async () => {
				const res = await a.api('sfxmGetById', params);
				commit('setProjectInfo', res.result);
			});
		},
		async getOperRecord({ commit }, params) {
			return helper(this, async () => {
				const res = await a.api('yskCzjl', {
					page_num: 1,
					page_size: 10,
					...params,
				});
				commit('setOperRecord', res.result.dsh.length);
			});
		},
		async getXfOperRecord({ commit }, params) {
			return helper(this, async () => {
				const res = await a.api('xfCzjl', {
					...params,
				});
				const temp = res.result.filter(item => item.sh_zt === 'DSH');
				commit('setXfOperRecord', temp.length || 0);
			});
		},
		async getOtherOperRecord({ commit }, params) {
			return helper(this, async () => {
				const res = await a.api('gradeExaminationOperationRecords', {
					page_num: 1,
					page_size: 10,
					...params,
				});
				const temp = res.result.filter(el => el.sh_zt === 'DSH').length;
				commit('setOperRecord', temp);
			});
		},
	},
};
